import { logger } from "./logger.model";
import { EEnvironmentType, Utilities as U } from '@app/shared/utilities/utilities.model';

export abstract class FluxModel {

  // lo store verrà impostato nelle successive implementazioni
  // in base alla classe associata
  // lo store dev'essere un'entità separata con i vari GET e SET
  // e non una mappa generica, come nel redux originale
  // private store: any;

  actions: string[] = [];
    
  // mappa le ACTION con gli eventi - mapping 1:N
  // un evento è praticamente l'associazione di un component a flux
  // una sorta di subscribe, con il quale rimane in attesa
  // in questo modo si può anche rimuovere
  // non può essere un array, bisogna associare la ACTION ad una mappa
  mapAction2EventList = new Map<string, Event[]>();
  
  // ACTION-reducers
  // mappa le ACTION con i REDUCER - mapping 1:N
  // una ACTION può avere più REDUCER
  // sembra inutile, perché il reducer viene memorizzato nell'evento
  // mapAction2ReducersList = new Map<string, Function[]>();

	constructor(actionList: string[]) {

    // TODO
    // 4) tipizzare le actions con l'enum

    try {

      if (U.isEmpty(actionList)) {
        throw new Error(EError.ACTION_LIST_EMPTY);
      }

      this.setActions(actionList);

      // per sicurezza
      this.actions.forEach(x => {
        this.mapAction2EventList.set(x, []);
        // this.mapAction2ReducersList.set(x, []);
      });
      
    } catch (e) {
      logger.error(e);
    }
  }  

  /**
   * Associa un REDUCER alla ACTION
   * 
   * @param {string[]} actionList
   */ 
  public setActions(actionList: string[]): void {
    this.actions = actionList;
  }  

  /**
   * Associa un REDUCER alla ACTION
   * 
   * @param {string} action
   * @param {Function} reducer
   */ 
  public setReducer(action: string, reducer: Function): FluxEvent {

    try {

      if (U.isEmpty(this.actions)) {
        throw new Error(EError.ACTION_LIST_EMPTY);
      }

      const fluxEvent = new FluxEvent(action);
  
      // in base alla singola ACTION
      // viene memorizzata una mappa chiave-valore anche per gli eventi
      // forse bisogna far restituire il nome dell'evento al component chiamante, per eliminarlo quando non serve
      let eventList = [fluxEvent.getEvent()];
      if (this.mapAction2EventList.has(action)) {
        eventList = [...this.mapAction2EventList.get(action), ...eventList];
      }
      this.mapAction2EventList.set(action, eventList);
  
      // viene memorizzata la callback per removeEventListener
      fluxEvent.setCallback(function(e) {
        // e.target
  
        // logger.log('register event listener ', fluxEvent.getName());
        
        // in teoria non dovrebbero esserci problemi di ricorsione
        
        // 1) se la ACTION è GET_DOSSIER, rimane in attesa finché 
        // da un'altra parte non viene eseguito SET_DOSSIER
        // che a catena fa eseguire eventDispatcher(GET_DOSSIER)
        
        // 2) la ACTION è SET_DOSSIER non dovrebbe chiaamare proprio il metodo
        // perché si prende direttamente con dispatch, senza passare per setReducer
        const content = this.dispatch(action);
        reducer(content);
      });
      
      // TODO
      // alcune callback vengono ripetute
      // setReducer non viene ripetuto
      document.addEventListener(fluxEvent.getName(), fluxEvent.getCallback().bind(this));
  
      // se c'è il dato in memoria bisogna eseguire subito il reducer
      const content = this.dispatch(action);
      if (!U.isEmpty(content)) {
        reducer(content);
      }

      return fluxEvent;

    } catch (e) {
      logger.error(e);
    }

  }

  /**
   * invoca una ACTION verso flux e aggiorna lo stato 
   * da implementare nella sottoclasse
   * 
	 * @param {string} action
	 * @param {any} payload
   */ 
  public dispatch(action: string, payload?: any): any {
  }
  
  /**
   *  
	 * ritorna l'evento associato alla action
   * 
	 * @param {string} action
	 * @returns {any}
   */ 
  getEventListByAction(action: string): Event[] {
    return (!U.isEmpty(this.mapAction2EventList) && this.mapAction2EventList.has(action)) ? this.mapAction2EventList.get(action) : null;
  }

  /**
	 * sostanzialmente un proxy per dispatchEvent
   * 
	 * @param {string} action
   */ 
  protected eventDispatcher(action: string): void {

    // logger.log(action);

    const eventList = this.getEventListByAction(action);
    
    // caso in cui la ACTION non è stata mai mappata
    if (U.isEmpty(eventList)) {
      return;
    }
    
    try {
      // vengono eseguiti tutti i REDUCER associati alla ACTION
      eventList.forEach(x => document.dispatchEvent(x));
    } catch(e) {
      // TODO
      // risolvere l'errore 
      // ERROR InvalidStateError: Failed to execute 'dispatchEvent' on 'EventTarget': The event is already being dispatched.
      // forse è un problema di concorrenza
      if (U.APPCONFIGENVIRONMENT.environment === EEnvironmentType.LOCAL) {
        // logger.error(e);
      }
    }
  }

  /**
	 * rimuove gli eventi associati 
   * solitamente è utilizzato nell'OnDestroy di un component
   * 
	 * @param {string[]} eventNameList
   */ 
  public removeEventListener(event: FluxEvent): void {

    const action = event.getAction();
    
    // logger.log(this.mapAction2EventList);
    
    if (this.mapAction2EventList.has(action)) {
      this.mapAction2EventList.set(action, 
        this.mapAction2EventList.get(action).filter(x => x.type !== event.getName())
      );

      document.removeEventListener(event.getName(), event.getCallback().bind(this));
    }

    // logger.log(this.mapAction2EventList);
  }
}

enum EError {
  ACTION_LIST_EMPTY = 'ACTION_LIST_EMPTY',
}

export class FluxEvent {

  private name: string = '';
  private action: string = '';
  private event: Event;
  private callback: Function;
  
  constructor(action: string) {
    this.action = action;    
    this.name = this.getEventIdByAction(this.action);
    this.event = new Event(this.name, { bubbles: true });
  }

  private  getEventIdByAction (action: string): string {    
    const EVENT_NAME_SEPARATOR = '__';

    const timestamp = Date.now(); // Get the current timestamp in milliseconds
    const randomString = Math.random().toString(36).substring(2, 10).toUpperCase(); // Generate a random string (alphanumeric)
    return `${action}${EVENT_NAME_SEPARATOR}${timestamp}${randomString}`; // Concatenate timestamp with random string to ensure uniqueness
  }

  getName(): string {
    return this.name;
  }

  getAction(): string {
    return this.action;
  }

  getEvent(): Event {
    return this.event;
  }

  getCallback(): Function {
    return this.callback;
  }

  setCallback(callback: Function): void {
    this.callback = callback;
  }
}